import { useAtomValue } from 'jotai';
import { RoccoLink } from '../../../components/link/RoccoLink';
import { uiFooterTrackingConfig } from './Footer';

interface NavigationMenuProps {
    title: string;
    links: NavigationMenuLinkProps[];
}

interface NavigationMenuLinkProps {
    title: string;
    to: string;
    isNonRemixRoute?: boolean;
    newTab?: boolean;
}

/**
 * Navigation links for the page footer.
 */
export const NavigationMenu = ({ title, links }: NavigationMenuProps) => {
    const trackingConfig = useAtomValue(uiFooterTrackingConfig);

    return (
        <div>
            <div className="mb-5 hidden text-base text-gray-900/50 md:block">
                {title}
            </div>
            <nav>
                <ul className="flex flex-col gap-y-2">
                    {links.map((link, index) => {
                        return (
                            <li key={index} className="my-1 md:my-0">
                                <RoccoLink
                                    className="block text-sm font-medium text-gray-900/50 hover:text-gray-900/80 md:text-base md:text-gray-900"
                                    to={link.to}
                                    newTab={link.newTab}
                                    prefetch="intent"
                                    isNonRemixRoute={link.isNonRemixRoute}
                                    onClick={() =>
                                        trackingConfig?.onNavClick(link.to)
                                    }
                                >
                                    {link.title}
                                </RoccoLink>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </div>
    );
};
